import React from "react";
import { DivisionsDataTable } from "./";

const DivisionsPage = () => {
  return (
    <div className="sub-content">
      <DivisionsDataTable />
    </div>
  );
};

export default DivisionsPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/divisions/DivisionsPage.js